<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-id-badge"></i></div>
      <div>
        Personnel
        <div class="page-title-subheading">Membres du personnel</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouveau personnel
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Activer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Désactiver</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>
               

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table table-striped table-hover table-borderless table-sm" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Photo</th>
                                    <th>Nom et prénom(s)</th>
                                    <th>Date et lieu de naissance</th>
                                    <th>Email</th>
                                    <th>Contact</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'personals' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>
                                        <img [src]="basePath+d.photo" class="img-thumbnail" height="100" width="100" alt="...">
                                    </td>
                                    <td>{{d.lastname}} {{d.firstname}}</td>
                                    <td>{{d.birthdate | date:"dd-MM-yyyy"}} {{d.birthplace}} </td>
                                    <td>{{d.email}}</td>
                                    <td>{{d.phone}}</td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un personnel</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="lastname" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="firstname" class="form-control" ngModel required>
            </div>
            
            <div class=" form-group col-12 mb-3">
                <label for="">Genre <span class="text-danger ml-2">(*)</span></label>
                <select name="sex" class="form-control" ngModel required >
                    <option value="Homme">Homme</option>
                    <option value="Femme">Femme</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="birthdate" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Lieu de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="birthplace" class="form-control" ngModel required>
            </div>
            
            <div class=" form-group col-12 mb-3">
                <label for="">Adresse <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="address" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Fonction <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="fonction" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="email" class="form-control" ngModel required>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="phone" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Observation particulière </label>
                <textarea name="observation" class="form-control" ngModel></textarea>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Photo </label>
                <input type="file" class="form-control" (change)="upload($event)">
            </div>
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier un personnel</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
        
            <div class=" form-group col-12 mb-3">
                <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="lastname" class="form-control" [(ngModel)]="selected_data.lastname" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="firstname" class="form-control" [(ngModel)]="selected_data.firstname" required>
            </div>
            
            <div class=" form-group col-12 mb-3">
                <label for="">Genre <span class="text-danger ml-2">(*)</span></label>
                <select name="sex" class="form-control" [(ngModel)]="selected_data.sex" required >
                    <option value="Homme">Homme</option>
                    <option value="Femme">Femme</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="birthdate" class="form-control" [(ngModel)]="selected_data.birthdate" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Lieu de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="birthplace" class="form-control" [(ngModel)]="selected_data.birthplace" required>
            </div>
            
            <div class=" form-group col-12 mb-3">
                <label for="">Adresse <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="address" class="form-control" [(ngModel)]="selected_data.address" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Fonction <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="fonction" class="form-control" [(ngModel)]="selected_data.fonction" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="email" class="form-control" [(ngModel)]="selected_data.email" required>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="phone" class="form-control" [(ngModel)]="selected_data.phone" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Observation particulière </label>
                <textarea name="observation" class="form-control" [(ngModel)]="selected_data.observation"></textarea>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Photo </label>
                <input type="file" class="form-control" (change)="upload($event)">
            </div>
        
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="text-center">
            <img [src]="basePath+selected_data.photo" class="img-thumbnail" alt="...">
        </div>
       <dl>
            <dt>Nom</dt>
            <dd>{{selected_data.lastname}}</dd>
       </dl>
       <dl>
            <dt>Prénom(s)</dt>
            <dd>{{selected_data.firstname}}</dd>
       </dl>
       <dl>
            <dt>Date de naissance</dt>
            <dd>{{selected_data.birthdate | date:"dd-MM-yyyy"}}</dd>
       </dl>
       <dl>
            <dt>Lieu de naissance</dt>
            <dd>{{selected_data.birthplace}}</dd>
       </dl>
       <dl>
            <dt>Sexe</dt>
            <dd>{{selected_data.sex}}</dd>
       </dl>
       <dl>
            <dt>Adresse</dt>
            <dd>{{selected_data.address}}</dd>
       </dl>
       <dl>
            <dt>Fonction</dt>
            <dd>{{selected_data.fonction}}</dd>
       </dl>
       <dl>
            <dt>Email</dt>
            <dd>{{selected_data.email}}</dd>
       </dl>
       <dl>
            <dt>Contact</dt>
            <dd>{{selected_data.phone}}</dd>
       </dl>
       <dl>
            <dt>Observation</dt>
            <dd>{{selected_data.observation}}</dd>
       </dl>
      </div>
</ng-template>
